import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Allow super_admin, admin, and supervisor roles
  const allowedRoles = ['super_admin', 'admin', 'supervisor'];
  if (!allowedRoles.includes(user.role)) {
    return <div>Access Denied. Admin access required.</div>;
  }

  return <>{children}</>;
};

export default PrivateRoute;

